import {
  type AdminAtRiskWorkersListParams,
  getAdminAtRiskWorkersListQueryOptions,
  getAdminAtRiskWorkersSummaryRetrieveQueryOptions,
} from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminAtRiskWorkersListParams };

export const atRiskWorkersQuery = ({ search }: QueriesInput) => getAdminAtRiskWorkersListQueryOptions(search);
export const atRiskSummaryQuery = () => getAdminAtRiskWorkersSummaryRetrieveQueryOptions();

export const queries = (input: QueriesInput): Array<WarmableQuery> => [atRiskWorkersQuery(input), atRiskSummaryQuery()];
